<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    switchFullscreen
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭">
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">

        <a-form-item label="品类名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['name', validatorRules.name]" placeholder="请输入品类名称"></a-input>
        </a-form-item>
        <a-form-item label=" 客如云分类Id" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['code', validatorRules.code]" placeholder=""></a-input>
        </a-form-item>
        <a-form-item label="是否启用" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag type="list" v-decorator="['isEnabled', validatorRules.isEnabled]" :trigger-change="true" dictCode="yn" placeholder="请选择是否启用"/>
        </a-form-item>
        <a-form-item label="排序号" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input-number v-decorator="['orderNum']" placeholder="请输入排序号" style="width: 100%"/>
        </a-form-item>
        <a-form-item label="渠道品类信息" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-textarea v-decorator="['channelCategoryInfo']" rows="4" placeholder="请输入渠道品类信息"/>
        </a-form-item>
        <a-form-item label="渠道" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-multi-select-tag type="list_multi" v-decorator="['typeChannel', validatorRules.typeChannel]" :trigger-change="true" dictCode="sales_channel,channel_name,id" placeholder="请选择渠道"/>
        </a-form-item>
        <a-form-item label="门店" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-search-select-tag v-decorator="['storeId', validatorRules.storeId]" dict="sales_physical_store,phystore_name,id" />
        </a-form-item>

      </a-form>
    </a-spin>
  </j-modal>
</template>

<script>

  import { httpAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JDictSelectTag from "@/components/dict/JDictSelectTag"
  import JMultiSelectTag from "@/components/dict/JMultiSelectTag"
  import JSearchSelectTag from '@/components/dict/JSearchSelectTag'



  export default {
    name: "ManufactureProductCategoryModal",
    components: { 
      JDictSelectTag,
      JMultiSelectTag,
      JSearchSelectTag,
    },
    data () {
      return {
        form: this.$form.createForm(this),
        title:"操作",
        width:800,
        visible: false,
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          name: {
            rules: [
              { required: true, message: '请输入品类名称!'},
            ]
          },
          /*code: {
            rules: [
              { required: true, message: '请输入 编码!'},
            ]
          },*/
          isEnabled: {
            rules: [
              { required: true, message: '请输入是否启用!'},
            ]
          },
          typeChannel: {
            rules: [
              { required: true, message: '请输入渠道!'},
            ]
          },
          storeId: {
            rules: [
              { required: true, message: '请输入门店!'},
            ]
          },
        },
        url: {
          add: "/manufacture/manufactureProductCategory/add",
          edit: "/manufacture/manufactureProductCategory/edit",
        }
      }
    },
    created () {
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'name','code','isEnabled','orderNum','channelCategoryInfo','typeChannel','storeId'))
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          }
         
        })
      },
      handleCancel () {
        this.close()
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'name','code','isEnabled','orderNum','channelCategoryInfo','typeChannel','storeId'))
      },

      
    }
  }
</script>